// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { LinkPresentationProps } from "@insite/mobius/Link";
import constants from "@store/constants";
import OrderActionSet from "@store/Library/Components/Toolkit/Order/OrderActionSet";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import QuickOrderFill from "@toolkit/Library/Components/Icons/QuickOrder/QuickOrderFill";
import React from "react";

export interface OrderUploadActionsStyles {
    quickOrderLink?: LinkPresentationProps;
}

export const orderUploadActionsStyles: OrderUploadActionsStyles = {
    quickOrderLink: { icon: { iconProps: { src: QuickOrderFill } } },
};

const styles = orderUploadActionsStyles;

const OrderUploadActions = () => {
    const quickOrderLink = usePageLinkByPageType(constants.pageType.quickOrder);

    return (
        <OrderActionSet
            displayType="link"
            actions={[
                {
                    key: "quick",
                    label: translate("Quick Order"),
                    linkStyles: styles.quickOrderLink,
                    testSelector: "uploadOrder_quickOrder",
                    href: quickOrderLink?.url,
                },
            ]}
        />
    );
};

const widgetModule: WidgetModule = {
    component: OrderUploadActions,
    definition: {
        group: "Order Upload",
        allowedContexts: ["OrderUploadPage"],
        displayName: "Actions",
    },
};

export default widgetModule;
